"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Required = exports.InputLabel = exports.FieldLabel = exports.FieldError = exports.FieldContainer = exports.FormField = exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  ", ";\n  width: 100%;\n  height: 48px;\n  background-color: ", ";\n  padding: 13px 15px;\n  border-radius: 4px;\n  color: ", ";\n  font-smooth: always;\n  letter-spacing: 0.4px;\n  appearance: none;\n  line-height: 1.25;\n  border: ", ";\n  &:focus {\n    border: 1px solid ", ";\n    background: ", ";\n    box-shadow: ", ";\n  }\n  &::placeholder {\n    color: ", ";\n    opacity: 1;\n  }\n  &::-ms-clear {\n    display: none;\n  }\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  ", ";\n  width: 100%;\n  height: 48px;\n  background-color: ", ";\n  padding: 13px 15px;\n  border-radius: 4px;\n  color: ", ";\n  font-smooth: always;\n  letter-spacing: 0.4px;\n  appearance: none;\n  line-height: 1.25;\n  border: ", ";\n  &:focus {\n    border: 1px solid ", ";\n    background: ", ";\n    box-shadow: ", ";\n  }\n  &::placeholder {\n    color: ", ";\n    opacity: 1;\n  }\n  &::-ms-clear {\n    display: none;\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n  ", ";\n  &:last-child {\n    margin-right: 0px;\n  }\n  position: relative;\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n  ", ";\n  &:last-child {\n    margin-right: 0px;\n  }\n  position: relative;\n  ", ";\n  ", ";\n"]),
    _templateObject3 = _taggedTemplateLiteral(["padding-bottom: 24px"], ["padding-bottom: 24px"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: 8px;\n  display: flex;\n"], ["\n  position: relative;\n  margin-bottom: 8px;\n  display: flex;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyText = require("buoy-text");

var _buoyTheme = require("buoy-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FormInput = _styledComponents2.default.input.attrs({
  tabIndex: function tabIndex(props) {
    return props.tabIndex || "0";
  },
  type: function type(props) {
    return props.fieldType || "text";
  },
  maxLength: function maxLength(props) {
    return props.maxLength || null;
  },
  "aria-label": function ariaLabel(props) {
    return props.ariaLabel || props.label || "";
  },
  placeholder: function placeholder(props) {
    return props.placeholder || props.label || "";
  }
}).withConfig({
  displayName: "src__FormInput",
  componentId: "sc-10u759v-0"
})(_templateObject, _buoyTheme.fontFamily, _buoyTheme.fontWeight.light, (0, _buoyTheme.fontSize)("bodyMain"), _buoyTheme.colors.neutralLightest, _buoyTheme.colors.neutralDarkest, function (props) {
  return props.error ? "1px solid " + _buoyTheme.colors.error(props) : "1px solid " + _buoyTheme.colors.neutralLightest(props);
}, _buoyTheme.colors.white, _buoyTheme.colors.white, _buoyTheme.constants.boxShadow, _buoyTheme.colors.neutral);

var FieldContainer = _styledComponents2.default.div.withConfig({
  displayName: "src__FieldContainer",
  componentId: "sc-10u759v-1"
})(_templateObject2, function (props) {
  return props.margin ? props.margin : (0, _buoyTheme.responsive)("margin", "0 12px 0 0", "0 12px 0 0", "0", "0", "0");
}, function (props) {
  return props.paddingBottom ? props.paddingBottom : (0, _styledComponents.css)(_templateObject3);
}, function (props) {
  return props.padding && props.padding;
});

var InputLabel = (0, _styledComponents2.default)(_buoyText.Label).withConfig({
  displayName: "src__InputLabel",
  componentId: "sc-10u759v-2"
})(_templateObject4);

var Required = function Required() {
  return _react2.default.createElement(
    "span",
    null,
    _react2.default.createElement(
      "sup",
      null,
      "*"
    )
  );
};

var FieldLabel = function FieldLabel(_ref) {
  var label = _ref.label,
      required = _ref.required;
  return _react2.default.createElement(
    InputLabel,
    null,
    label,
    required && _react2.default.createElement(Required, null)
  );
};

var FieldError = function FieldError(_ref2) {
  var message = _ref2.message;
  return _react2.default.createElement(
    _buoyText.ErrorMessage,
    null,
    message
  );
};

var FormField = function FormField(_ref3) {
  var props = _objectWithoutProperties(_ref3, []);

  return _react2.default.createElement(
    FieldContainer,
    props,
    props.label && _react2.default.createElement(FieldLabel, { required: props.required, label: props.label }),
    _react2.default.createElement(FormInput, _extends({}, props, {
      error: props.showError,
      margin: props.inputMargin || "0"
    })),
    props.showError && props.errorMessage && _react2.default.createElement(FieldError, { message: props.errorMessage })
  );
};

exports.default = FormInput;
exports.FormField = FormField;
exports.FieldContainer = FieldContainer;
exports.FieldError = FieldError;
exports.FieldLabel = FieldLabel;
exports.InputLabel = InputLabel;
exports.Required = Required;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-input/dist/index.js
// module id = 225
// module chunks = 168707334958949